import { Injectable, inject } from "@angular/core";

import { CommonDialogsService } from "@tylertech/common-dialogs-module";
import { AggregateHelperService, IAggregateActionHandler } from "@tylertech/aggregates-module";
import { IAggregate, ICardData, ICardAction, ExecutionResult } from "@tylertech/tyler-api-types";

import { UBDashboardService } from "../services/ubdashboard.service";
import { CatchupBillingCriteria } from "../interfaces";

@Injectable()
export class CatchUpBillingActionHandler implements IAggregateActionHandler
{
    private readonly $commonDialogsService = inject(CommonDialogsService);
    private readonly $aggregateHelperService = inject(AggregateHelperService);
    private $ubDashboardService = inject(UBDashboardService);


    predicate(aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): boolean
    {
        return aggregate.AggregateProviderId === "Utility.CatchUpBilling";
    }

    execute(_aggregate: IAggregate, cardData: ICardData, action: ICardAction): Promise<boolean>
    {
        if (action.Id === "CreateCatchUpBillingSingleAccount")
        {
            this.executeCatchUpBillingSingleAccount(cardData);
        }
        else if (action.Id === "CreateCatchUpBillingWholePacket")
        {
            this.executeCatchUpBillingPacket(cardData);
        }
        return Promise.resolve(true);
    }

    private executeCatchUpBillingSingleAccount(cardData: ICardData): void
    {
        const accountId = this.$aggregateHelperService.getFieldValue(cardData, "AccountId");
        const originalPacketId = this.$aggregateHelperService.getFieldValue(cardData, "OriginalPacketId");
        const criteria: CatchupBillingCriteria = {
            AccountId: accountId,
            OriginalPacketId: originalPacketId,
        };

        this.$ubDashboardService.processCatchUpBillingSingleAccount(criteria)
            .then(
                (result: ExecutionResult<string>) => this.respondToResult(result),
                _result => this.handleError())
            .finally(() =>
            {
                window.location.reload();
            });
    }

    private executeCatchUpBillingPacket(cardData: ICardData): void
    {
        const originalPacketId = this.$aggregateHelperService.getFieldValue(cardData, "OriginalPacketId");
        this.$ubDashboardService.processCatchUpBillingPacket(originalPacketId)
            .then(
                (result: ExecutionResult<string>) => this.respondToResult(result),
                _result => this.handleError())
            .finally(() =>
            {
                window.location.reload();
            });
    }

    private respondToResult(executionResult: ExecutionResult<string>): Promise<void>
    {
        const lineBreak = "<br />";
        const htmlErrorResult = executionResult.Result.replace(/\r?\n|\r/g, lineBreak);
        const htmlErrorMessage = executionResult.ErrorMessage.replace(/\r?\n|\r/g, lineBreak);

        if (!executionResult.Success)
        {

            if (executionResult.Result && !/^\W+$/.test(executionResult.Result))
            {
                return this.$commonDialogsService.showAlertHtmlMessage(
                    `${htmlErrorResult}
${lineBreak}
${lineBreak}
${htmlErrorMessage}`,
                    "Catch Up Billing Succeeded with Errors"
                );
            }

            return this.$commonDialogsService.showAlertHtmlMessage(
                htmlErrorMessage,
                "Catch Up Billing Failed");
        }

        return this.$commonDialogsService.showAlertHtmlMessage(
            htmlErrorResult, "Catch Up Billing Succeeded");
    }

    private handleError(): Promise<void>
    {
        return this.$commonDialogsService.showAlertHtmlMessage(
            "Check ERP PR0 10 logs for more information",
            "Catch Up Billing Failed");
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
